import { POSTAL_CODE_LENGTH } from '@shared/constants/numbers';

export const validatePhoneNumber = (value?: string | null) =>
  value && value.match(/\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}/g);

export const validateEmail = (value?: string | null) =>
  value &&
  value.match(
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu
  );

export const validatePostalCode = (value?: string | null) => !value || (value && value.length === POSTAL_CODE_LENGTH);

export const isNumber = (value: string) => value && !value.match(/[^0-9]/);
